import { memo } from "react";

function CustomerComments(props) {
  const { color = "#666666"} = props;
  return (
    <svg
      width="14"
      height="15"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_8365_1513)">
        <path
          d="M15 2H3C2.175 2 1.5075 2.675 1.5075 3.5L1.5 17L4.5 14H15C15.825 14 16.5 13.325 16.5 12.5V3.5C16.5 2.675 15.825 2 15 2ZM15 12.5H3.8775L3.435 12.9425L3 13.3775V3.5H15V12.5ZM7.875 11H13.5V9.5H9.375L7.875 11ZM10.77 6.5975C10.92 6.4475 10.92 6.215 10.77 6.065L9.4425 4.7375C9.2925 4.5875 9.06 4.5875 8.91 4.7375L4.5 9.1475V11H6.3525L10.77 6.5975Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_8365_1513">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default memo(CustomerComments);
